class Search {
    constructor() {
        // console.log("Hello, I am a search");
    }

    keyPressDispatcher(e) {
        console.log(e.key);
    }
}

var search = new Search();
